import classNames from 'classnames';

import CardEditButton from '../../../components/card-edit-button/card-edit-button';
import PaymentMethodItem from '../../../components/payment-method-item/payment-method-item';
import Card from '../../../components/card/card';
import { PaymentMethod } from '../../../types/payment-config.type';
import styles from '../plan.module.scss';

type Props = {
    currentStep: number;
    priceType: string;
    methods: PaymentMethod[];
    shown: boolean;
    onStep: (step: number) => void;
    onMethod: (code: string) => void;
};

const PaymentMethodsCard = ({
    currentStep,
    priceType,
    methods,
    shown,
    onStep,
    onMethod,
}: Props) => {
    return (
        <Card
            className={classNames({
                [styles.card]: true,
                [styles.shown]: currentStep > 2 && shown,
                [styles.paymentMethods]: true,
            })}
        >
            <CardEditButton
                shown={currentStep !== 3}
                onClick={() => onStep(3)}
            />
            <span
                className={classNames({
                    [styles.cardTitle]: true,
                    [styles.active]: currentStep === 3,
                })}
            >
                ¿Qué método de pago te va mejor?
            </span>
            <ul className={styles.paymentMethodsList}>
                {methods.map((method, idx) => (
                    <PaymentMethodItem
                        key={idx}
                        active={
                            method.code === 'TDCSTRIPE' ||
                            priceType === 'one_time'
                        }
                        name={method.displayName}
                        description={method.description ?? ''}
                        onClick={() => onMethod(method.code)}
                    />
                ))}
            </ul>
        </Card>
    );
};

export default PaymentMethodsCard;
